export const DEVELOPMENT = 'Development';
export const TESTING = 'Testing';
export const DEMO = 'Demo';
export const LIVE = 'Live';

export const NAN = 'NAN';
export const COMPANY = 'COMPANY';
export const FRANCHISEE = 'FRANCHISEE';
export const CLIENT = 'CLIENT';